import "@arco-design/web-react/es/Carousel/style";
import _Carousel from "@arco-design/web-react/es/Carousel";
import React from 'react';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
export default function LoginBanner() {
  const t = useLocale(locale);
  const data = [{
    slogan: t['login.banner.slogan1'],
    subSlogan: t['login.banner.subSlogan1'],
    image: 'http://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/6c85f43aed61e320ebec194e6a78d6d3.png~tplv-uwbnlip3yd-png.png'
  }, {
    slogan: t['login.banner.slogan2'],
    subSlogan: t['login.banner.subSlogan2'],
    image: 'http://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/6c85f43aed61e320ebec194e6a78d6d3.png~tplv-uwbnlip3yd-png.png'
  }, {
    slogan: t['login.banner.slogan3'],
    subSlogan: t['login.banner.subSlogan3'],
    image: 'http://p1-arco.byteimg.com/tos-cn-i-uwbnlip3yd/6c85f43aed61e320ebec194e6a78d6d3.png~tplv-uwbnlip3yd-png.png'
  }];
  return /*#__PURE__*/React.createElement(_Carousel, {
    className: styles.carousel,
    animation: "fade"
  }, data.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: `${index}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['carousel-item']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['carousel-title']
  }, item.slogan), /*#__PURE__*/React.createElement("div", {
    className: styles['carousel-sub-title']
  }, item.subSlogan), /*#__PURE__*/React.createElement("img", {
    alt: "banner-image",
    className: styles['carousel-image'],
    src: item.image
  })))));
}